import { createContext, ComponentProps } from "react";
import type CustomButton from "../CustomButton";

export type CapturedActionButton = ComponentProps<typeof CustomButton>;

export interface ActionMenuComponentContextValue {
  register: (button: CapturedActionButton | null) => void;
  restoreFocus: () => void;
}

export const ActionMenuComponentContext =
  createContext<ActionMenuComponentContextValue | null>(null);
